// Copyright (c) 2019 Deere & Company

import actions from '../../app/shared/actions-list';

export const updateOktaAccessToken = accessToken => ( {
    accessToken,
    type: actions.UPDATE_OKTA_STATE_ACCESS_TOKEN
} );

export const updateOktaIsAuthenticated = isAuthenticated => ( {
    isAuthenticated,
    type: actions.UPDATE_OKTA_STATE_IS_AUTHENTICATED
} );

export const updateOktaUserFirstName = userFirstName => ( {
    type: actions.UPDATE_OKTA_STATE_USER_FIRST_NAME,
    userFirstName
} );
